import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-create-prompt-step',
  templateUrl: './create-prompt-step.component.html',
  styleUrls: ['./create-prompt-step.component.scss'],
  standalone: false
})
export class CreatePromptStepComponent {

  @Input() form!: FormGroup;
  @Output() filesSelected = new EventEmitter<File>();

  constructor() {}
  
  getControl(control: string) {
    return this.form!.get(control) as FormControl;
  }

  onFileSelected(files: any): void {
    if (files?.length) {
      this.filesSelected.emit(files);
    }
  }
}
